import { render, staticRenderFns } from "./ApiCredentials.vue?vue&type=template&id=aab0c420&scoped=true&"
import script from "./ApiCredentials.vue?vue&type=script&lang=js&"
export * from "./ApiCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0c420",
  null
  
)

export default component.exports